// extracted by mini-css-extract-plugin
export default {"wrapper":"RejectHorseModal_wrapper__9MBs8","icon":"RejectHorseModal_icon__k2uLA"};